<template>
  <IconLucideCircleX />
</template>
